function About() {
    return (
        <section id="about">
          <h2 id="sectionHead">Spec Sheet</h2>
          <p id="me">
              I love learning, I am passionate in gaining knowledge in a variety of fields and thrilled to find solutions to new or existing problems. I’ve collaborated in creating projects through which I gained essential communication and teamwork skills.
              <br/>
              Using online resources I’ve gained skills in the following frameworks, libraries, tools, and languages: Flutter, Django, Flask, Node.js, React, Vue.js, Three.js, Blender, Unreal engine, unity, Docker, MongoDB, Git, Haskell, Bash, MATLAB, FreeRTOS, Solidity, and Blockchain architecture. Apart from the above I am confident I can quickly pickup any new tool required to solve any problem.
          </p>
          <section id="skills"></section>
        </section>
    );
  }
  
  export default About;
  